import styled from 'styled-components';
import FlightIconSvg from '../assets/hotels/thankyou/flight.svg';
import {defaultTheme} from 'build-theme/src/build-theme';

const FlightIcon = styled(FlightIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2rem'};
  height: ${props => props.height || '2rem'};
  fill: ${props => props.fill || defaultTheme.colors.grey.grey50};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default FlightIcon;
